// Redux
import { connect, ConnectedProps } from 'react-redux';
import { setFilterMenuUnderstood } from 'src/store/notification/actions';
import { RootState } from 'src/store/rootReducer';
/// Components
import { Box, Grid, IconButton } from '@material-ui/core';
import { InformationPopper } from 'src/components/General';

export const SearchToogleButtonMobile = ({
  filterUnderstood,
  onSearchClick,
  setFilterMenuUnderstoodAction,
}: Props): JSX.Element => {
  return (
    <Grid
      item
      xs={6}
      container
      justifyContent="flex-end"
      data-testid="search-toogle-button-mobile"
    >
      <Box sx={{ marginRight: 10 }}>
        <InformationPopper
          information="Encuentra aquí filtros para mostrar las pólizas según su estado."
          onUnderstood={setFilterMenuUnderstoodAction}
          title="Filtros para pólizas y cotizaciones"
          open={!filterUnderstood}
        >
          <IconButton
            data-testid="search-icon"
            onClick={onSearchClick}
            id="sales-web-button-search"
          >
            <img alt="search" src="/svg/search_icon.svg" />
          </IconButton>
        </InformationPopper>
      </Box>
    </Grid>
  );
};

export const mapStateToProps = (
  state: RootState,
): {
  filterUnderstood: boolean;
} => ({
  filterUnderstood: state.notification.filterUnderstood,
});

const reduxActions = {
  setFilterMenuUnderstoodAction: setFilterMenuUnderstood,
};

const connector = connect(mapStateToProps, reduxActions);
type Props = ConnectedProps<typeof connector> & {
  onSearchClick: () => void;
};

export default connector(SearchToogleButtonMobile);
